export default __webpack_public_path__ + "static/black-friday-bags-with-text-54b5f17b4716700d34a05ee9520f71a5.svg";